import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Unauthorized() {
  const { user } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-dark-900">
      <div className="text-center">
        <div className="mb-8 text-8xl">🚫</div>
        <h1 className="mb-4 text-2xl font-bold text-dark-100">Access Denied</h1>
        <p className="mb-2 text-dark-400">
          You don't have permission to access this page.
        </p>
        {user && (
          <p className="mb-8 text-sm text-dark-500">
            Logged in as <strong>{user.name}</strong> ({user.role})
          </p>
        )}
        <Link to="/dashboard" className="btn btn-primary">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
